<script setup lang="ts">
  import { computed } from 'vue';

  const statusMap = {
    '': '근무시작 전',
    WORK_START: '근무 중',
    AWAY_START: '쉬는 중',
    AWAY_END: '근무 중',
    WORK_END: '근무 종료',
  } as const;

  const props = withDefaults(
    defineProps<{ status?: keyof typeof statusMap }>(),
    {
      status: '',
    }
  );
  const statusText = computed(() => statusMap[props.status]);
</script>

<template>
  <div
    class="ml-1 badge font-bold"
    :class="{
      'badge-error': !status,
      'badge-success': status === 'WORK_START' || status === 'AWAY_END',
      'badge-secondary': status === 'AWAY_START',
      'badge-neutral': status === 'WORK_END',
    }">
    {{ statusText }}
  </div>
</template>
